import { LEGACY_DARK_MODE_STORAGE_KEY, LEGACY_INTERPRETER_THEME_STORAGE_KEY, THEME_MODE_STORAGE_KEY, getSystemThemeMode, getThemePreference, normalizeThemePreference, resolveThemeMode, setThemePreference, subscribeToSystemTheme } from '../../base/ui/theme-mode';
import { getBrowserPreferenceItem, setPersistentItem } from '../../vrs-auth/storage';
const preferenceKeys = new Set([
    THEME_MODE_STORAGE_KEY,
    LEGACY_DARK_MODE_STORAGE_KEY,
    LEGACY_INTERPRETER_THEME_STORAGE_KEY
]);
const copy = {
    en: { appearance: 'Appearance', system: 'System', light: 'Light', dark: 'Dark' },
    ar: { appearance: 'المظهر', system: 'النظام', light: 'فاتح', dark: 'داكن' }
};
const controls = [];
let preference = getThemePreference(getBrowserPreferenceItem);
/** Apply the shared stored preference before the page body is painted. */
function applyAppearance() {
    const mode = resolveThemeMode(preference, getSystemThemeMode());
    const text = document.documentElement.lang.startsWith('ar') ? copy.ar : copy.en;
    const changed = document.documentElement.dataset.theme !== mode
        || document.documentElement.dataset.themePreference !== preference;
    document.documentElement.dataset.theme = mode;
    document.documentElement.dataset.themePreference = preference;
    document.documentElement.style.colorScheme = mode;
    for (const { label, select } of controls) {
        label.textContent = text.appearance;
        select.value = preference;
        for (const option of Array.from(select.options)) {
            const value = normalizeThemePreference(option.value);
            if (value) {
                option.textContent = text[value];
            }
        }
    }
    if (changed) {
        window.dispatchEvent(new Event('mcg-appearance-change'));
    }
}
function updatePreference(value) {
    const selected = normalizeThemePreference(value);
    if (selected) {
        preference = selected;
        setThemePreference(setPersistentItem, selected);
        applyAppearance();
    }
}
window.McgAppearance = {
    getPreference: () => preference,
    setPreference: updatePreference
};
/** Mount the same accessible preference control without requiring AdminShell. */
function mountControls() {
    for (const slot of Array.from(document.querySelectorAll('[data-admin-appearance-slot]'))) {
        const wrapper = document.createElement('label');
        const label = document.createElement('span');
        const select = document.createElement('select');
        wrapper.className = 'admin-appearance';
        select.dataset.adminAppearance = '';
        for (const value of ['system', 'light', 'dark']) {
            const option = document.createElement('option');
            option.value = value;
            select.appendChild(option);
        }
        select.addEventListener('change', () => updatePreference(select.value));
        wrapper.append(label, select);
        slot.replaceChildren(wrapper);
        controls.push({ label, select });
    }
    applyAppearance();
    document.documentElement.dataset.adminAppearanceReady = 'true';
}
// Treat events as invalidations: their value can already be stale after rapid
// changes in another tab. Never write the event payload back to shared storage.
function refreshPreference() {
    preference = getThemePreference(getBrowserPreferenceItem);
    applyAppearance();
}
window.addEventListener('storage', event => {
    if (event.key === null || preferenceKeys.has(event.key)) {
        refreshPreference();
    }
});
window.addEventListener('pageshow', event => {
    if (event.persisted) {
        refreshPreference();
    }
});
subscribeToSystemTheme(applyAppearance);
new MutationObserver(applyAppearance).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['lang']
});
applyAppearance();
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountControls, { once: true });
}
else {
    mountControls();
}
